import { useState, useEffect } from 'react';
import { client } from '../api/client';

interface LeaderEntry { rank: number; userId: string; totalPractices: number; correctCount: number; accuracy: number; topicsCovered: number; }

export function LeaderboardPage() {
  const [data, setData] = useState<LeaderEntry[]>([]);
  const [loading, setLoading] = useState(true);
  const [period, setPeriod] = useState('week');

  useEffect(() => {
    setLoading(true);
    client.api.fetch(`/api/public/leaderboard?period=${period}`)
      .then(r => r.json())
      .then(d => { setData(d.data || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, [period]);

  const medals = ['🥇', '🥈', '🥉'];

  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-slate-800">🏆 排行榜</h1>
        <div className="flex gap-2">
          {[{v:'week',l:'本周'},{v:'month',l:'本月'},{v:'all',l:'全部'}].map(p => (
            <button key={p.v} onClick={() => setPeriod(p.v)}
              className={`px-3 py-1.5 rounded-lg text-sm ${period === p.v ? 'bg-blue-600 text-white' : 'bg-slate-100 text-slate-600 hover:bg-slate-200'}`}>
              {p.l}
            </button>
          ))}
        </div>
      </div>

      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        {loading ? (
          <div className="p-12 text-center"><div className="animate-spin w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full mx-auto" /></div>
        ) : data.length === 0 ? (
          <div className="p-12 text-center text-slate-400">
            <p className="text-4xl mb-2">🏅</p>
            <p>暂无排行数据</p>
            <p className="text-sm">开始做题，争夺排行榜吧！</p>
          </div>
        ) : (
          <table className="w-full">
            <thead className="bg-slate-50">
              <tr>
                <th className="px-4 py-3 text-left text-sm font-medium text-slate-600">排名</th>
                <th className="px-4 py-3 text-left text-sm font-medium text-slate-600">用户</th>
                <th className="px-4 py-3 text-center text-sm font-medium text-slate-600">答对</th>
                <th className="px-4 py-3 text-center text-sm font-medium text-slate-600">总题数</th>
                <th className="px-4 py-3 text-center text-sm font-medium text-slate-600">正确率</th>
                <th className="px-4 py-3 text-center text-sm font-medium text-slate-600">主题数</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {data.map(e => (
                <tr key={e.rank} className={`hover:bg-slate-50 ${e.rank <= 3 ? 'bg-yellow-50/50' : ''}`}>
                  <td className="px-4 py-3 text-lg">{e.rank <= 3 ? medals[e.rank - 1] : <span className="text-slate-400 text-sm">{e.rank}</span>}</td>
                  <td className="px-4 py-3 font-medium text-slate-800">{e.userId.length > 10 ? e.userId.slice(0, 8) + '...' : e.userId}</td>
                  <td className="px-4 py-3 text-center text-emerald-600 font-semibold">{e.correctCount}</td>
                  <td className="px-4 py-3 text-center text-slate-600">{e.totalPractices}</td>
                  <td className="px-4 py-3 text-center">
                    <span className={`px-2 py-0.5 rounded text-sm font-medium ${e.accuracy >= 80 ? 'bg-emerald-100 text-emerald-700' : e.accuracy >= 60 ? 'bg-yellow-100 text-yellow-700' : 'bg-red-100 text-red-700'}`}>
                      {e.accuracy}%
                    </span>
                  </td>
                  <td className="px-4 py-3 text-center text-slate-600">{e.topicsCovered}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
